import { Box, Grid } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useEffect, useState } from 'react';
import {
  MEDICAL_HEALTH_INFORMATION_BRANCH_NAME,
  MEDICAL_HEALTH_INFORMATION_ERROR_NAME,
  STATUS_COLOR
} from '../constants/constants';
import { MedicalHealthInformationData } from '../types/MedicalHealthInformation';
import { parseDate, parseTime, parseMedicalInformationStatus } from '../func/parse';
import ErrorDialog from '@/features/misc/ErrorDialog';
import { useLoading } from '@/hooks/useLoading';
import { useMedicalHealthInformationContext } from '../Context';
import { NoListError } from '../errors/errors';

// 一覧カードの横幅
const listCardWidth = 353;

const MedicalHealthInformation = () => {
  const [errorDialogOpen, setErrorDialogOpen] = useState<boolean>(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState<string>('');
  const { loadingEvent, Loading } = useLoading();
  const {
    medicalHealthInformationList,
    setActiveStep,
    fetchMedicalHealthInformationList,
    setActiveMedicalHealthInformation
  } = useMedicalHealthInformationContext();

  useEffect(() => {
    loadingEvent(async () => {
      try {
        await fetchMedicalHealthInformationList();
      } catch (error) {
        if (error instanceof NoListError) {
          setActiveStep(MEDICAL_HEALTH_INFORMATION_ERROR_NAME);
        } else if (error instanceof Error) {
          setErrorDialogMessage(error.message);
          setErrorDialogOpen(true);
        }
      }
    });
    // マウント時のみ実行させたいのでdisable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (data: MedicalHealthInformationData) => {
    setActiveMedicalHealthInformation(data);
    setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_NAME);
  };

  return (
    <Loading>
      <Box sx={{ marginTop: '16px' }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={0} md={3} sm={2} />
          <Grid item xs={12} md={6} sm={8}>
            <Grid container spacing={2} sx={{ paddingX: '20px', maxWidth: `calc(${listCardWidth}px *2 + 20px)` }}>
              {medicalHealthInformationList.map((data, key) => {
                const status = parseMedicalInformationStatus(data);
                return (
                  <Grid
                    item
                    key={key}
                    xs={12}
                    md={6}
                    sx={{ width: `${listCardWidth}px`, justifyContent: 'center', display: 'flex' }}
                  >
                    <Box sx={{ width: `${listCardWidth}px`, padding: '4px', backgroundColor: 'white' }}>
                      <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'space-between' }}>
                        <button
                          onClick={() => {
                            handleClick(data);
                          }}
                          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        ></button>
                        <Box sx={{ marginLeft: '10px', marginTop: '10px', fontWeight: 600, textAlign: 'left' }}>
                          <p style={{ fontSize: '10px' }}>
                            {`予約 : ${parseDate(data.reserve_date)} ${parseTime(data.reserve_time)}`}
                            {status && <span style={STATUS_COLOR[status]}>{status}</span>}
                          </p>
                          <p style={{ fontSize: '14px' }}>{data.facility_name}</p>
                        </Box>
                        <Box sx={{ lineHeight: '50px' }}>
                          <ArrowForwardIosIcon></ArrowForwardIosIcon>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          <Grid item xs={0} md={3} sm={2} />
          <ErrorDialog
            open={errorDialogOpen}
            title={'医療健康情報一覧エラー'}
            buttonLabel="閉じる"
            buttonAction={() => {
              setErrorDialogOpen(false);
            }}
          >
            {errorDialogMessage}
          </ErrorDialog>
        </Grid>
      </Box>
    </Loading>
  );
};
export default MedicalHealthInformation;
